import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import './AdminLayout.css'; // Importamos el CSS maestro

const AdminLayout = () => {
  return (
    <div className="admin-container">
      <Sidebar />
      <main className="main-content">
        {/* El Outlet inyecta la pantalla seleccionada */}
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;